import { LOCATION_CHANGE } from '../../utils/constants';

export const changeLocation = location => {
  return { type: LOCATION_CHANGE, payload: { ...location } };
};
